export enum ReloadTypesEnum {
  NATIVE = 'native',
  LINK = 'link',
}
